import React from 'react';
import { Outlet, useLocation } from 'react-router';
import { Header } from './Header';
import { BottomNav } from './BottomNav';
import { InstallPrompt } from '../pwa/InstallPrompt';
import { cn } from '../../utils/cn';

interface LayoutProps {
  children?: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();

  const isAdmin = location.pathname.startsWith('/admin');
  const isAuth = ['/login', '/register'].includes(location.pathname);

  if (isAuth) {
    return (
      <main className="min-h-screen bg-bg-darker flex items-center justify-center">
        <div className="w-full max-w-md mx-auto px-4">
          {children || <Outlet />}
        </div>
      </main>
    );
  }

  return (
    <div className="min-h-screen bg-bg-darker">
      {!isAdmin && <Header />}

      <main
        role="main"
        className={cn(
          'min-h-screen mx-auto',
          // Responsive max-width: mobile full, tablet 768px, desktop 1024px for content
          'max-w-full md:max-w-3xl lg:max-w-5xl xl:max-w-6xl',
          !isAdmin && 'pt-20 md:pt-24 pb-24 md:pb-8' // More spacing for header + bottom nav on mobile
        )}
      >
        {children || <Outlet />}
      </main>

      {/* Bottom nav only on mobile */}
      {!isAdmin && <BottomNav />}

      {/* PWA Install Prompt */}
      {!isAdmin && <InstallPrompt />}
    </div>
  );
};

export default Layout;
